import localDB from "./localDB";

let GLOBAL = require('./globals');

const PartialOpenBoxData = {
    async post(data, res) {
        await fetch(`${GLOBAL.BASE_URL}open-box-current/partial`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async put(data, res) {
        await fetch(`${GLOBAL.BASE_URL}partial-open-box/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}partial-open-box/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default PartialOpenBoxData;



// WEBPACK FOOTER //
// ./src/data/PartialOpenBoxData.js